import { message } from "antd";
var common = {
  webRootPath:"",
  defaultTable : {
    columns : [],  //标题
    dataSource : [],  //数据
    pagination: {
      current : 1,
      total : 0,
      pageSize : 10,
      showQuickJumper : true,
      showSizeChanger : true,
      pageSizeOptions : ["10"]
    },
    loading : false,  //loading状态
    bordered : false,  //是否有边框
    show : false
  },
  getDefaultTable : function(){
    const a = common.defaultTable;
    const b = common.getObj(a);
    return b;
  },
  getEcardTable : function(table){
    const defaultTable = common.getDefaultTable();
    const columnsList = table.columnsList;

    let columnsShow = [];
    let mustList = [];
    common.eachObj(columnsList, function(index, dataItem){
      const dataIndex = dataItem.dataIndex;
      if(dataItem.must) mustList.push(dataIndex);
      if(dataItem.show) columnsShow.push(dataIndex);
    })
    table = Object.assign(defaultTable, table);
    table.columnsShow = columnsShow;
    table.columns = columnsList;
    table.mustList = mustList;
    table.scroll = common.getScroll(table);
    table.show = true;
    return table;
  },
  getScroll : function(table){
    const id = table.id;
    var scroll = 0;
    common.eachObj(table.columns, function(index, dataItem){
      if(dataItem.width){
        scroll = scroll + parseInt(dataItem.width, 10)
      } else {
        scroll = scroll + 100
      };
    });
    var a = document.getElementById(id);
    var width = a ? a.offsetWidth : 0;
    scroll = scroll > width ? scroll : width;
    return { x : scroll};
  },
  request:function(postData, obj, callback, errback){ //（提交参数，当前组件，成功回调，失败回调）
    var _url = common.webRootPath + postData["_url"];
    delete postData["_url"];

    var _method = "post";
    if(postData["_method"]){
      _method = postData["_method"];
      delete postData["_method"];
    }
    switch(_method){
      case "GET":case "DELETE":
        var a = 0;
        postData["t"] = postData["t"] = Math.floor(new Date().getTime()/3000);
        common.eachObj(postData, function(key, value){
          if(a === 0 && _url.indexOf("?") < 0){
            _url = _url + "?";
          } else {
            _url = _url + "&";
          }
          switch(typeof(value)){
            // case "object":
            //   if(value.length > 0){
            //     common.eachObj(value, function(index, dataItem){
            //       console.log("!" + dataItem)
            //       if(index === value.length) {
            //         _url = _url + key + "=" + dataItem;
            //       } else {
            //         _url = _url + key + "=" + dataItem + "&";
            //       }
            //     });
            //   }
            //   break;
            default:
              _url = _url + key + "=" + value;
              break;
          }
          a++;
        });
        fetch(_url,{
          credentials: 'include',//'include'
          method: _method,
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
          },
        }).then(response => response.json())
        .then(data => common.requestReturn(data, obj, callback, errback));
        break;
      default:
        postData = JSON.stringify(postData);
        fetch(_url,{
          credentials: 'include',//'include'
          method: _method,
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
          },
          body:postData,
        }).then(response => response.json())
        .then(data => common.requestReturn(data, obj, callback, errback));
        break;
    }
  },
  requestReturn:function(data, obj, callback, errback){
    if(data.status === 200){
      if(callback){
        callback(obj, data);
      }
    } else {
      if(data.status === 403){
        // message.warning(data.message);
        window.location.href = "#/login";
      } else {
        if(errback){
          errback(obj, data);
        } else {
          message.warning(data.message);
        }
      }
    }
  },
  setUrlName:function(postData){
    var a = 0;
    var url = ""
    common.eachObj(postData, function(key, value){
      if(a === 0){
        url = url + "?" +  key + "=" + value;
      } else {
        url = url + "&" + key + "=" + value;
      }
      a++;
    });
    return url;
  },
  strToDate:function(time) {
    if (time === null || time === "") {
      return '';
    } else {
      if(typeof(time) === "number" || typeof(time) === "string") if(time.toString().indexOf(" ") > -1) time = time.replace(" ", "T");
      var datetime = new Date(time);
      var year = datetime.getFullYear();
      var month = datetime.getMonth() + 1 < 10 ? "0" + (datetime.getMonth() + 1) : datetime.getMonth() + 1;
      var date = datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();
      return year + "-" + month + "-" + date;
    }
  },
  strToTime:function(time){
    if(time === null || time === "") {
      return '';
    } else {
      var datetime = new Date();
      datetime.setTime(time);
      var year = datetime.getFullYear();
      var month = datetime.getMonth() + 1 < 10 ? "0" + (datetime.getMonth() + 1) : datetime.getMonth() + 1;
      var date = datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();
      var hour = datetime.getHours()< 10 ? "0" + datetime.getHours() : datetime.getHours();
      var minute = datetime.getMinutes()< 10 ? "0" + datetime.getMinutes() : datetime.getMinutes();
      var second = datetime.getSeconds()< 10 ? "0" + datetime.getSeconds() : datetime.getSeconds();
      return year + "-" + month + "-" + date+" "+hour+":"+minute+":"+second;
    }
  },
  strToHour:function(time) {
    function pad(num, n) {  
      var len = num.toString().length;  
      while(len < n) {  
          num = "0" + num;  
          len++;
      }  
      return num;  
    }  
    if (time === null || time === "") {
      return '';
    } else {
      if(typeof(time) === "number" || typeof(time) === "string") if(time.toString().indexOf(" ") > -1) time = time.replace(" ", "T");
      var datetime = new Date(time);
      var hour = datetime.getHours();
      var minutes = datetime.getMinutes();
      var seconds = datetime.getSeconds();
      return pad(hour, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2);
    }
  },
  getObj : function(obj){
    return JSON.parse(JSON.stringify(obj))
  },
  eachObj:function(obj, call){
    if(!obj) return ;
    if(common.ifObjectEmpty(obj)) return;
    for(const key of Object.keys(obj)){
      if(call){
        call(key, obj[key]);
      } else {
        console.log(key, obj[key]);
      }
    }
  },
  ifNull:function(text){
    return text?text:"";
  },
  ifObjectEmpty: function(obj){
    for (var key in obj) {
      return false;
    }
    return true;
  },
  toMonth : function(num){
    if(!num) num = 0;
    const now = new Date(new Date().setDate(1));
    var month = now.getMonth();
    const iniDate = common.strToDate(now.setMonth(month + num));
    return iniDate;
  },
  toDay : function(num, type){
    if(!num) num = 0;
    const now = new Date();
    const date = now.getDate();
    var iniDate = common.strToDate(now.setDate(date + num));
    if(type || type === 0){
      if(type === 0){
        iniDate = iniDate + " 00:00:00";
      }
      if(type === 1){
        iniDate = iniDate + " 23:59:59";
      }
    }
    return iniDate;
  },
  //form检验空格
  checkSpace: function (rule, value, callback){
    var reg = /^\s*(\S+)\s*$/;
    if (reg.test(value)) {
      callback('请输入内容');
    } else {
      callback();
    }
  },
  validChinese : function (rule, value, callback){
    var reg = /[\u4E00-\u9FA5]/gi;
    if (!reg.test(value)) {
      callback();
    } else {
      callback('不能输入中文');
    }
  },
  checkPhone : function(rule, value, callback){
    var myreg = /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1}))+\d{8})$/;
    if (value && value.length !== 11 && !myreg.test(value)) {
      callback('请输入正确的手机号');
    } else {
      callback();
    }
  },
  checkIdCard : function(rule, value, callback){
    var myreg = /(^\d{15}$)|(^\d{17}([0-9]|X)$)/ ;
    if (value && !myreg.test(value)) {
      callback('请输入正确的身份证号');
    } else {
      callback();
    }
  },
  IsPC : function(){
    var userAgentInfo = navigator.userAgent;
    var Agents = ["Android", "iPhone",
                "SymbianOS", "Windows Phone",
                "iPad", "iPod"];
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
        }
    }
    return flag;
  },
  getQueryString : function(name){
    var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if(r!=null)return  unescape(r[2]); return null;
  },
  getUrl : function(name){
    var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
    var url = window.location.hash.split("?")[1];
    if(!url) return null;
    var r = url.match(reg);
    if(r!=null)return  unescape(r[2]); return null;
  },
  lookUpTree : function(tree, subList,key, value){ //树， 子集键， 查找的键， 查找的值
    var a = [];
    if(!key || !value) return a;
    loop(tree);
    function loop(list){
      common.eachObj(list, function(index, dataItem){
        if(dataItem[subList]) loop(dataItem[subList]);
        if(dataItem[key] === value) {
          a.push(dataItem);
        }
      });
    }
    return a;
 },
 lookUpParent : function(tree, subList,key, value){ //树， 子集键， 查找的键， 查找的值
   var a = [];
   if(!key || !value) return a;
   var keys = [];
   loop(tree);
   function loop(list){
     common.eachObj(list, function(index, dataItem){
       if(dataItem[subList]) {
         keys.push(dataItem)
         loop(dataItem[subList]);
       }
       if(dataItem[key] === value) {
         keys.push(dataItem)
         a.push(keys);
         keys = [];
         return;
       }
       if(index === (list.length-1).toString()){
         keys.splice(keys.length-1,1)
       }
     });
   }
   return a;
 },
 setCookie : function(cname,cvalue,exdays){
   var d = new Date();
   d.setTime(d.getTime()+(exdays*24*60*60*1000));
   var expires = "expires="+d.toGMTString();
   document.cookie = cname+"="+cvalue+"; "+expires;
 },
 getCookie : function(cname){
   var name = cname + "=";
   var ca = document.cookie.split(';');
   for(var i=0; i<ca.length; i++) {
       var c = ca[i].trim();
       if (c.indexOf(name) === 0) { return c.substring(name.length,c.length); }
   }
   return "";
 },
 showPage : function(pageType, pageData){
   this.setState({ pageType, pageData })
 },
 // 去两位小数
 toThNum : function(str) {
   var num = parseFloat(str).toFixed(3);//这里因为我需要两位小数所以做一个限制，你们看情况做小数位的限制
   var s = num.substring(0, (num.length-1));//只取小数位2位

   return s && s.toString().replace(/(\d)(?=(\d{3})+\.)/g, function($0, $1) {
       return $1 + ",";
   });
 },
 delSpace : function(str) {
   const value = str.replace(/\s+/g,"");
   return value;
 }
}
window.common = common;
export default common;



// WEBPACK FOOTER //
// ./src/assets/common.js